// extracted by mini-css-extract-plugin
module.exports = {"banner":"errorMessage_banner__JMfpH","message":"errorMessage_message__X_dj5","iconContainer":"errorMessage_iconContainer__VoqrS"};